import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AdminScreenContextService {
  private _rowData = new BehaviorSubject<any>({});
  private _gridData = new BehaviorSubject<any>(null);

  readonly rowData$ = this._rowData.asObservable();
  readonly gridData$ = this._gridData.asObservable();

  get rowData(): any { return this._rowData.value; }
  get gridData(): any { return this._gridData.value; }

  /**
   * True when the admin context owns either a selected row or a loaded grid.
   * Both signals indicate "we are inside an admin screen" so consumers should
   * NOT fall back to workspace activeScreen.
   */
  get hasContext(): boolean {
    const rd = this._rowData.value;
    const gd = this._gridData.value;
    const hasRow = rd != null && typeof rd === 'object' && Object.keys(rd).length > 0;
    const hasGrid = gd != null;
    return hasRow || hasGrid;
  }

  setRowData(data: any): void { this._rowData.next(data ?? {}); }
  setGridData(data: any): void { this._gridData.next(data ?? null); }

  clear(): void {
    this._rowData.next({});
    this._gridData.next(null);
  }
}
